import { render, staticRenderFns } from "./detailDialog.vue?vue&type=template&id=5b50aa1e"
import script from "./detailDialog.vue?vue&type=script&lang=ts"
export * from "./detailDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports